import { createGlobalStyle } from 'styled-components';
import helpers from '@gloat/helpers';
import colors from '../style/colors';
import styleConstants from './constants';
import { pulse } from './animations';
import { deviceSizes } from './device';

const SharedGlobalStyle = createGlobalStyle`
    /**********************
	Normalize.css
	**********************/
    /*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */

    //
    // 1. Set default font family to sans-serif.
    // 2. Prevent iOS text size adjust after device orientation change,
    //    without disabling user zoom.
    //

    html {
        font-family: sans-serif; // 1
        -ms-text-size-adjust: 100%; // 2
        -webkit-text-size-adjust: 100%; // 2


    }

    //
    // Remove default margin.
    //
    // gloat: commenting this to prevent flickering in Cordova Webview
    body {
        margin: 0;

    }

    // gloat: fix for desktop
    @media (min-width: 767px) {
        body {
            margin: 0;
        }
    }

    // HTML5 display definitions
    // ==========================================================================

    //
    // Correct \`block\` display not defined for \`details\` or \`summary\` in Firefox.
    //

    details,
    summary {
        display: block;
    }

    //
    // Normalize vertical alignment in Chrome, Firefox, and Opera.
    //

    audio,
    canvas,
    progress,
    video {
        vertical-align: baseline;
    }

    // Prevent modern browsers from displaying \`audio\` without controls.
    // Remove excess height in iOS 5 devices.

    audio:not([controls]) {
        display: none;
        height: 0;
    }

    //
    // Hide the \`template\` element in Safari, and Firefox < 22.
    //

    template {
        display: none !important;
    }

    // Links
    // ==========================================================================

    //
    // Improve readability of focused elements when they are also in an
    // active/hover state.
    //

    a:active,
    a:hover {
        outline: 0;
    }

    // Text-level semantics
    // ==========================================================================

    //
    // Address styling not present in Safari, and Chrome.
    //

    abbr[title] {
        border-bottom: 1px dotted;
    }

    //
    // Address style set to \`bolder\` in Firefox 4+, Safari, and Chrome.
    //

    b,
    strong {
        font-weight: 500;
    }

    //
    // Address styling not present in Safari and Chrome.
    //

    dfn {
        font-style: italic;
    }

    //
    // Address variable \`h1\` font-size and margin within \`section\` and \`article\`
    // contexts in Firefox 4+, Safari, and Chrome.
    //

    h1 {
        font-size: 2em;
        margin: 0.67em 0;
    }

    //
    // Address inconsistent and variable font size in all browsers.
    //

    small {
        font-size: 80%;
    }

    //
    // Prevent \`sub\` and \`sup\` affecting \`line-height\` in all browsers.
    //

    sub,
    sup {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
    }

    sup {
        top: -0.5em;
    }

    sub {
        bottom: -0.25em;
    }

    // Grouping content
    // ==========================================================================

    //
    // Address margin not present in Safari.
    //

    figure {
        margin: 1em 40px;
    }

    //
    // Address differences between Firefox and other browsers.
    //

    hr {
        box-sizing: content-box;
        height: 0;
    }

    //
    // Contain overflow in all browsers.
    //

    pre {
        overflow: auto;
    }

    //
    // Address odd \`em\`-unit font size rendering in all browsers.
    //

    code,
    kbd,
    pre,
    samp {
        font-family: monospace, monospace;
        font-size: 1em;
    }

    // Forms
    // ==========================================================================

    //
    // Known limitation: by default, Chrome and Safari on OS X allow very limited
    // styling of \`select\`, unless a \`border\` property is set.
    //

    //
    // 1. Correct color not being inherited.
    //    Known issue: affects color of disabled elements.
    // 2. Correct font properties not being inherited.
    // 3. Address margins set differently in Firefox 4+, Safari, and Chrome.
    //

    button,
    input,
    optgroup,
    select,
    textarea {
        color: inherit; // 1
        font: inherit; // 2
        margin: 0; // 3
    }

    //
    // Address inconsistent \`text-transform\` inheritance for \`button\` and \`select\`.
    // All other form control elements do not inherit \`text-transform\` values.
    // Correct \`button\` style inheritance in Firefox and Opera.
    // Correct \`select\` style inheritance in Firefox.
    //

    button,
    select {
        text-transform: none;
    }

    //
    // 1. Avoid the WebKit bug in Android 4.0.* where (2) destroys native \`audio\`
    //    and \`video\` controls.
    // 2. Correct inability to style clickable \`input\` types in iOS.
    // 3. Improve usability and consistency of cursor style between image-type
    //    \`input\` and others.
    //

    button,
    html input[type="button"], // 1
    input[type="reset"],
    input[type="submit"] {
        -webkit-appearance: button; // 2
        cursor: pointer; // 3
    }

    //
    // Re-set default cursor for disabled elements.
    //

    button[disabled],
    html input[disabled] {
        cursor: default;
    }

    //
    // Remove inner padding and border in Firefox 4+.
    //

    button::-moz-focus-inner,
    input::-moz-focus-inner {
        border: 0;
        padding: 0;
    }

    //
    // Address Firefox 4+ setting \`line-height\` on \`input\` using \`!important\` in
    // the UA stylesheet.
    //

    input {
        line-height: normal;
    }

    //
    // It's recommended that you don't attempt to style these elements.
    // Firefox's implementation doesn't respect box-sizing, padding, or width.
    //

    input[type='checkbox'],
    input[type='radio'] {
        box-sizing: border-box;
        padding: 0;
    }

    //
    // Fix the cursor style for Chrome's increment/decrement buttons. For certain
    // \`font-size\` values of the \`input\`, it causes the cursor style of the
    // decrement button to change from \`default\` to \`text\`.
    //

    input[type='number']::-webkit-inner-spin-button,
    input[type='number']::-webkit-outer-spin-button {
        height: auto;
    }

    //
    // 1. Address \`appearance\` set to \`searchfield\` in Safari and Chrome.
    // 2. Address \`box-sizing\` set to \`border-box\` in Safari and Chrome.
    //

    input[type='search'] {
        -webkit-appearance: textfield; // 1
        box-sizing: content-box; //2
    }

    //
    // Remove inner padding and search cancel button in Safari and Chrome on OS X.
    // Safari (but not Chrome) clips the cancel button when the search input has
    // padding (and \`textfield\` appearance).
    //

    input[type='search']::-webkit-search-cancel-button,
    input[type='search']::-webkit-search-decoration {
        -webkit-appearance: none;
    }

    //
    // Define consistent border, margin, and padding.
    //

    fieldset {
        border: 1px solid #c0c0c0;
        margin: 0 2px;
        padding: 0.35em 0.625em 0.75em;
    }

    //
    // Remove padding so people aren't caught out if they zero out fieldsets.
    //

    legend {
        padding: 0; // 2
    }

    //
    // Don't inherit the \`font-weight\` (applied by a rule above).
    // NOTE: the default cannot safely be changed in Chrome and Safari on OS X.
    //

    optgroup {
        font-weight: bold;
    }

    // Tables
    // ==========================================================================

    //
    // Remove most spacing between table cells.
    //

    table {
        border-collapse: collapse;
        border-spacing: 0;
    }

    td,
    th {
        padding: 0;
    }

    /**********************
	End of Normalize.css
	**********************/
    html,
    body, main {
        width: 100%;
        height: 100%;
    }

    body {
        margin-right: 8px;
        font-family: 'Roboto', sans-serif;
        -webkit-font-smoothing: antialiased;
        font-size: 1rem;
        position: relative;
        background: white;
        height: 100%;

    }

    fieldset {
        border: none;
    }


    * {
        scroll-behavior: smooth;
    }

    a {
        text-decoration: none;
        cursor: pointer;
    }

    p {
        margin: 0;
    }

    h1, h2, h3, h4, h5, h6 {
        padding: 0;
        margin: 0;
        -webkit-font-smoothing: antialiased;
    }

    *:focus {
        outline: none;
    }

    h1,
    h2,
    h3,
    h4, h5, h6 {
        font-family: 'Poppins', sans-serif;
    }

    ul,
    ol {
        margin: 0;
        padding: 0;
        border: 0;

        li {
            margin: 0;
            padding: 0;
        }
    }


    *,
    :after,
    :before {
        box-sizing: border-box;
    }


    a:focus-visible:not([data-highlighted]) {
        border: 1px solid ${colors.sky};
    }

    #main-app-container {
        height: 100%;
        padding-top: ${helpers.isArrivedFromWebview() || helpers.teams.isUnderTeams() ? 0 : styleConstants.headerHeight}px;
    }

    .intercom-icon-open {
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAkCAYAAADo6zjiAAAAAXNSR0IArs4c6QAAAr5JREFUWAntVz2MEkEUluXnTuGQwxAwV2ihMRcLicTSaywwdhZezsbKmtrKikQajN0lhsLC2JlcYujBGEJBIZ5iAwnEkJCYEORfWBa/b8Pc7S23d7kTttqXPObtvDfv++bN7DJju3Aotpkp2kPPYq3pLJ1o1UeCSv1+f1tRlO/T6VSGLlpk5N4HxhNiQQ8mqoJ3Op3tRSMa5QPWERIk4JxMJvtGAxbdD6xvxGQV1NnzASBdtA6oGSLbbDYPgMZcCwpbs8CJRywVWxA42BD0miQqpiBgEuY8jEXAqoBVAasCVgWsChhWQJblOs4I8vzfx9l7cABpGI06lsB4PC47nc576XT64Wg0+mE0+LR+5KkVCoWnDofjLuyKUTxJXNIeu8D4TyaTuY9+XygUCpRKpec4TH5mRbRxBrYyHA4L5XI5FolEriLHejab3WJObTwxoWoB5gjMAv92u93k7u7uBgIvQ6/EYrGbxWLxWb1ef9VsNt+32+096CfYHxqNxmsSTSQStxkL9aVSqWvI8Qb5Rlpw2vCfSkAdg6N0ezAYvK1UKg/C4bAPA0mGrV+n6/RFo1F/tVp9hDHvMLanBxbPiFUJiEPpKhw9dJ4oiGmhlF+xQX9Cf8PuYIAdsoZ1DkE3Yd/BgdN9YiI4ZzFDQWAFyX5JksTSmSKCgHgLpr1eb88UZB0ICXBDKPF4/CV27xedf+mPXAKxDC7Yq/l8fisYDN5Cic5zT7B7vd5Nt9sdcblcN5BPVHhuImIJBAEGMJjXJXFpoO+sIiYjJZPJjR1IIBDYwUftuj6RICD6BRGSIAESOY+yiivQi1BevXwejyeQy+Uet1qtj3gtB/rXEDFHRBD5n5aTEBMhIZJZg/r5IavVai/weefllP0SgZYh2ryCkCBlB6ACHUFlbeAyiDCnwGBLJREKSSjCqfYs+edYrH/16LJPC4LGtQAAAABJRU5ErkJggg==);

        &.mobile {
            position: relative;
            top: 2px;
            width: 13px;
            height: 13px;
            display: inline-block;
            background-size: 100%;
        }
    }

    .modal-open .modal {
        overflow-x: hidden;
        overflow-y: auto;
    }

    label {
        cursor: inherit;
    }

    button {
        padding: 0;
    }

    strong {
        font-weight: 500;
    }

    .pulse-hover {
        animation: ${pulse} 600ms 2;
    }

    ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: transparent;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: ${colors.gray400};
        border-radius: 4px;
    }

    /* Capitalize first letter of a string */
    .capitalize-first-letter {
        display: inline-block;

        &::first-letter {
            text-transform: capitalize;
        }

    }


    .text-ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: initial;
    }

    /* Transformation */
    .text-lowercase {
        text-transform: lowercase;
    }

    .text-uppercase {
        text-transform: uppercase;
    }

    .text-capitalize {
        text-transform: capitalize;
    }


    .visible-sm-flex {
        display: none !important;

        @media (max-width: ${deviceSizes.sm}) {
            display: flex !important;
        }
    }

    .visible-xs-flex {
        display: none !important;

        @media (max-width: ${deviceSizes.xs}) {
            display: flex !important;
        }
    }

    .visible-xxs-flex {
        display: none !important;

        @media (max-width: ${deviceSizes.xs}) {
            display: flex !important;
        }
    }

    .visible-sm {
        display: none !important;

        @media (max-width: ${deviceSizes.sm}) {
            display: inline-block !important;
        }
    }

    .visible-xs {
        display: none !important;

        @media (max-width: ${deviceSizes.xs}) {
            display: inline-block !important;
        }
    }
	
	.visible-sm {
        display: none !important;

        @media (max-width: ${deviceSizes.sm}) {
            display: inline-block !important;
        }
		
	}

    .hidden-xs {
        @media (max-width: ${deviceSizes.xs}) {
            display: none !important;
        }
    }


    .hidden-sm {
        @media (max-width: ${deviceSizes.sm}) {
            display: none !important;
        }
    }

    .hidden-md {
        @media (max-width: ${deviceSizes.md}) {
            display: none !important;
        }
    }

    .absolute-center {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .img-responsive {
        display: block;
        max-width: 100%;
        height: auto;
    }

    // if we render p inside span it usually means we render html coming from server and there we want p to have bottom margin
    // on our Text component we don't want p to have bottom margin by default.
    span p {
        margin-bottom: 8px;
    }

    // for alt text of broken images
    img {
        font-size: 10px;
    }

    i {
        font-style: normal;
    }

    .toasts-viewport {
        list-style-type: none;

    }

    /* Material Icons font loading fix - hide icons until font loads to prevent showing text labels */
    .material-symbols-outlined {
        visibility: hidden;
		overflow: hidden;
        transition: opacity 0.3s ease;
    }

    .fonts-loaded .material-symbols-outlined {
        visibility: visible;
		overflow: visible;
    }
`;

export default SharedGlobalStyle;
